import React, { useEffect, useState, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import PublicRouter from "./public-router";
import { publicRoute } from "./routes";
import { LoaderComponent } from "../shared/components/loaders/page-loader";
import { DrawerHeader } from "../shared/components/navigations/side-nav";
import { useTransactionCertificateStore } from "../store/transaction-certificates.store";
import { TCAppConfig } from "../shared/app-configs/tc-app-configs";
import { useApi } from "../shared/hooks/useApi";
import _ from 'lodash';
import { Typography } from "@mui/material";

const AuthRoute: React.FC = () => {
  const { cbLicensingCode, getUserInfo, setUserInfo, setCbLicensingCode } = useTransactionCertificateStore();
  const [loading, setLoading] = useState<boolean>(true);
  const [isNoEmail,setNoEmail] =  useState<boolean>(false);
  const { executeGet } = useApi();
  useEffect(() => {
    console.log(`getUserInfo from authroute ${getUserInfo}`)
    // Fetch CB Licensing Code if it is not already set
    const fetchCBLicensingCode = async () => {
      if (!cbLicensingCode) {
        // Assume getUserInfo fetches or returns the current user info
        const userInfo = await getUserInfo;
        if (userInfo && userInfo?.userEmail) {
          const response: any = await executeGet(TCAppConfig.GET_CB_CO_CODE, {
            email: userInfo?.userEmail,
          });
          if (response?.status === 200 && response?.data?.length > 0) {
            // Optionally update user info in your store if needed
            const updatedUserInfo = { ...userInfo };
            setUserInfo(updatedUserInfo);
            // Set the CB Licensing Code (assuming the first element's ID)
            setCbLicensingCode(response?.data[0]?.ID);
            // setCbLicensingCode("CB-DCS");
          }
        }else if( !_.isEmpty(userInfo?.displayName) && !userInfo?.userEmail){
          setLoading(false);
          setNoEmail(true);
        }
      }
      // Mark loading as complete after the API call attempt
      setLoading(false);
    };

    fetchCBLicensingCode();
  }, [cbLicensingCode, getUserInfo, setUserInfo, setCbLicensingCode]);

  if (loading || !cbLicensingCode) {
    // Show loader while fetching data
    return <LoaderComponent />;
  }else if(isNoEmail){
    return(
      <LoaderComponent error = {true} errorMsg="Since you donot have a valid email, you donot have access to the application"/>
    )
  }

  return (
    <Suspense fallback={<><DrawerHeader /><LoaderComponent /></>}>
      <Routes>
        {/* If licensing code is present, immediately redirect to /tc-dashboard */}
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route element={<PublicRouter />}>
          {publicRoute?.map(({ path, id, component: Component }) => (
            <Route key={id} path={path} element={<Component />} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AuthRoute;